import React, { useState } from "react";
import { Card, CardBody, Col, Collapse, FormGroup, Label, Row } from "reactstrap";
import { ChevronDown, ChevronRight } from "react-feather";
import { SeoMetaFields } from "../../../Common/SeoMetaFields";
import { useProductVariantContext } from "../../../../context/hooks/useProductVariant";
import { getProductSeoPreviewUrl } from "../../../../utils/seoPreviewUrls";

export default function ProductVariantSeoSection() {
  const { data, setData } = useProductVariantContext();
  const [isOpen, setIsOpen] = useState(false);

  const updateVariantSeo = (index, field, value) => {
    setData((rows) =>
      rows.map((row, rowIndex) =>
        rowIndex === index ? { ...row, [field]: value } : row
      )
    );
  };

  if (!data?.length) {
    return null;
  }

  return (
    <Row className="mb-5">
      <Col sm="12">
        <Card>
          <CardBody>
            <FormGroup
              className="d-flex align-items-center justify-content-between mb-0"
              style={{ cursor: "pointer" }}
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <Label className="mb-0" style={{ cursor: "pointer" }}>SEO — Meta Title & Description</Label>
              {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            </FormGroup>

            <Collapse isOpen={isOpen}>
              <div className="pt-3">
                {data.map((variant, index) => (
                  <div
                    key={variant._id || `variant-seo-${index}`}
                    className={index > 0 ? "mt-4 pt-4 border-top" : ""}
                  >
                    {data.length > 1 && (
                      <FormGroup>
                        <Label>{variant.variantName?.trim() || `Variant ${index + 1}`}</Label>
                      </FormGroup>
                    )}
                    <SeoMetaFields
                      metaTitle={variant.metaTitle}
                      metaDescription={variant.metaDescription}
                      onMetaTitleChange={(e) =>
                        updateVariantSeo(index, "metaTitle", e.target.value)
                      }
                      onMetaDescriptionChange={(e) =>
                        updateVariantSeo(index, "metaDescription", e.target.value)
                      }
                      urlPreview={getProductSeoPreviewUrl(variant)}
                    />
                  </div>
                ))}
              </div>
            </Collapse>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
